(function($) {
  function sideMenu() {
    $("body").append('<div class="sideNavBg"></div>');
    $("#gheader .gnavBtn, #gsideMenu .menuBtn, .sideNavBg").on(
      "click",
      function() {
        $("body").toggleClass("sideMenuOpen");
        return false;
      }
    );
  }

  function headerMenu() {
    $("#gheader .linkTxt").click(function() {
      if ($("#gheader .linkMenu").hasClass("is_active")) {
        $("#gheader .linkMenu").on("transitionend", function() {
          $(
            "#gheader .linkMenuList .parent, #gheader .linkMenuList .subList"
          ).removeClass("is_active");
        });
      }
      $("#gheader .linkMenu").toggleClass("is_active");
    });
    $(document).on("click", function(event) {
      if (
        $("#gheader .linkMenu").hasClass("is_active") &&
        !$(event.target).closest("#gheader .linkMenu").length &&
        !$(event.target).hasClass("linkTxt")
      ) {
        $("#gheader .linkMenu").removeClass("is_active");
      }
    });
    $("#gheader .linkMenuList .parentLink").click(function() {
      if (
        $(this)
          .closest(".parent")
          .hasClass("is_active")
      ) {
        return true;
      } else {
        $(
          "#gheader .linkMenuList .parent, #gheader .linkMenuList .subList"
        ).removeClass("is_active");
        $(this)
          .next(".subList")
          .addClass("is_active")
          .closest(".parent")
          .addClass("is_active");
        return false;
      }
    });
  }

  function gnav() {
    $("#gheader .gnavBtn").click(function() {
      $(this).toggleClass("is_active");
      $("#gnav").toggleClass("is_active");
      $("#gheader").toggleClass("is_fixed");
    });
  }

  function seachNav() {
    $("#gheader .search a").click(function() {
      $("#seachNav").addClass("is_active");
      return false;
    });
    $("#seachNav .navClose").click(function() {
      $("#seachNav").removeClass("is_active is_subShow");
    });
    $("#seachNav .subLinkCol .closeBtn").click(function() {
      $("#seachNav").removeClass("is_subShow");
      $("#seachNav .parent").removeClass("is_active");
    });
    var catLabel, listHTML;
    $("#seachNav .parentLink").click(function() {
      if (
        $(this)
          .closest(".parent")
          .hasClass("is_active") &&
        window.innerWidth >= 667
      ) {
        return true;
      }
      catLabel = $(this).text();
      listHTML = $(this)
        .next(".subList")
        .html();
      $("#seachNav .subLinkCol .catLabel").text(catLabel);
      $("#seachNav .subLinkCol .linkList").html(listHTML);
      $("#seachNav").addClass("is_subShow");
      return false;
    });
  }
  $(function() {
    sideMenu();
    headerMenu();
    gnav();
    seachNav();
  });
})(jQuery);
